/**
 * @generated SignedSource<<ad1fc2962e1377ac9cd84203dba67704>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BranchPickerSharedRepositoryBranches$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"BranchPickerSharedRef">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "BranchPickerSharedRepositoryBranches";
};
export type BranchPickerSharedRepositoryBranches$key = {
  readonly " $data"?: BranchPickerSharedRepositoryBranches$data;
  readonly " $fragmentSpreads": FragmentRefs<"BranchPickerSharedRepositoryBranches">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "BranchPickerSharedRepositoryBranches"
};

(node as any).hash = "517565275c8c3567fb16d44dc03f9b3b";

export default node;
